import { useCallback } from 'react';
import { Dialog, Pane, TextInputField, TextareaField, SelectField } from 'evergreen-ui';
import FileUploaderMultipleUploadDemo from '../../commons/FileUploaderMultipleUploadDemo';
import { DOCUMENT_MIME_TYPES_NO_SPREADSHEET } from '../../constants/uploadMimeTypes';
import { normalizeTimeInput } from './normalizeTimeInput';
import { useRole } from '../../contexts/RoleContext';

export default function TurniFerieRequestModal({
  isOpen,
  onClose,
  onRequest,
  ferieInputs,
  setFerieInputs,
  collaboratorsList,
  selfName,
}) {
  const { effectiveIsDirector: isDirector } = useRole();
  const handleFilesChange = useCallback((files) => {
    setFerieInputs({ ...ferieInputs, file: files });
  }, [ferieInputs, setFerieInputs]);

  return (
    <Dialog
      isShown={isOpen}
      title={isDirector ? "Inserisci assenza" : "Richiesta assenza"}
      onCloseComplete={onClose}
      confirmLabel={isDirector ? "Inserisci" : "Invia richiesta"}
      onConfirm={onRequest}
      shouldAutoFocus={false}
    >
      {isDirector && (
        <SelectField
          label="Collaboratore"
          value={ferieInputs.operator_name || ''}
          onChange={e => setFerieInputs({ ...ferieInputs, operator_name: e.target.value })}
        >
          {selfName && <option key="self" value={selfName}>{selfName} (io)</option>}
          {(collaboratorsList || []).map(c => {
            const full = `${c.nome} ${c.cognome}`.trim();
            return <option key={c.id} value={full}>{full}</option>;
          })}
        </SelectField>
      )}
      <SelectField
        label="Tipo di assenza"
        value={ferieInputs.type || 'Ferie'}
        onChange={e => setFerieInputs({...ferieInputs, type: e.target.value})}
        autoFocus
      >
        <option value="Ferie">Ferie</option>
        <option value="Permesso">Permesso</option>
        <option value="Malattia">Malattia</option>
        <option value="Infortunio">Infortunio</option>
      </SelectField>

      <Pane display="flex" flexWrap="wrap" gap={16}>
        <TextInputField
          flex={1}
          minWidth={120}
          label="Data inizio"
          type="date"
          value={ferieInputs.start_date}
          onChange={e => setFerieInputs({...ferieInputs, start_date: e.target.value})}
        />
        <TextInputField
          flex={1}
          minWidth={120}
          label="Data fine"
          type="date"
          value={ferieInputs.end_date}
          onChange={e => setFerieInputs({...ferieInputs, end_date: e.target.value})}
        />
      </Pane>

      {(ferieInputs.type === 'Ferie' || ferieInputs.type === 'Permesso') && (
        <Pane display="flex" flexWrap="wrap" gap={16}>
          <TextInputField
            flex={1}
            minWidth={120}
            label="Ora inizio"
            type="text"
            placeholder="es. 9 oppure 09:30"
            value={ferieInputs.start_time || ''}
            onChange={e => setFerieInputs({...ferieInputs, start_time: e.target.value})}
            onBlur={e => setFerieInputs({...ferieInputs, start_time: normalizeTimeInput(e.target.value)})}
          />
          <TextInputField
            flex={1}
            minWidth={120}
            label="Ora fine"
            type="text"
            placeholder="es. 17 oppure 17:30"
            value={ferieInputs.end_time || ''}
            onChange={e => setFerieInputs({...ferieInputs, end_time: e.target.value})}
            onBlur={e => setFerieInputs({...ferieInputs, end_time: normalizeTimeInput(e.target.value)})}
          />
        </Pane>
      )}

      <TextareaField
        label="Motivazione o note"
        value={ferieInputs.motivazione}
        onChange={e => setFerieInputs({...ferieInputs, motivazione: e.target.value})}
      />
      
      <FileUploaderMultipleUploadDemo onFilesChange={handleFilesChange} acceptedMimeTypes={DOCUMENT_MIME_TYPES_NO_SPREADSHEET} />
    </Dialog>
  );
}